module.exports = __webpack_public_path__ + "img/consumer-studies.3ea6dcbc.svg";